import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { GetDocumentReviewsResponse, ReviewClientModel, SaveDocumentReviewRequest, SaveFormReviewRequest } from "../models/document-review.models";

@autoinject
export class DocumentReviewApi {

    public documenReviewApi: string = `${this.configService.config.urls.documentManagementApiUrl}/api/v1/DocumentReview`;

    constructor(private configService: ConfigService, private requestClientService: RequestClientService) { }
    
    //get document reviews
    public getDocumentReviews(vesselId: number, customerId: number = null): Promise<GetDocumentReviewsResponse> {
        return this.requestClientService.get(`${this.documenReviewApi}/GetDocumentReviews/${vesselId}`, { customerId: customerId });
    }
    
    //save form review
    public saveFormReview(request : SaveFormReviewRequest): Promise<ReviewClientModel> {
        return this.requestClientService.post(`${this.documenReviewApi}/SaveFormReview`, {}, request);
    }
    
    //save document review
    public saveDocumentReview(request: SaveDocumentReviewRequest): Promise<ReviewClientModel> {
        return this.requestClientService.post(`${this.documenReviewApi}/SaveDocumentReview`,{}, request);
    }
}